import axios, { CancelToken } from "axios";
//import { toJS } from "mobx";
// import Qs from 'qs';
const qs = require("qs");

class Api {
  // BASE_URL = 'http://ec2-3-14-3-244.us-east-2.compute.amazonaws.com';
  BASE_URL =
    process.env.NODE_ENV === "production"
      ? window.location.protocol + "//" + window.location.host + "/"
      : "http://wewp-plugins.com/";
  WP_AJAX_URL = `${this.BASE_URL}wp-admin/admin-ajax.php`;

  constructor() {
    axios.defaults.baseURL = this.WP_AJAX_URL;
    axios.defaults.withCredentials = true;
    axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded; charset=UTF-8";
  }

  wpPrepareDateRequest = (data: any) => {
    return qs.stringify(JSON.parse(JSON.stringify(data)));
  };

  getTemplates = async (
    offset: number = 0,
    limit: number = 6,
    filter: string | null = "",
    cancelToken: CancelToken | undefined = undefined
  ) => {
    try {
      const data = {
        action: "get_templates",
        offset,
        limit,
        filter
      };

      const response = await axios.post(``, this.wpPrepareDateRequest(data), {
        cancelToken: cancelToken ? cancelToken : undefined
      });
      return response;
    } catch (err) {
      let response = {};
      if (err.response) {
        response = {
          data: err.response.data,
          statusText: err.response.statusText,
          status: err.response.status
        };
      }

      return response;
    }
  };

  getTemplate = async (id: number) => {
    try {
      const data = {
        action: "get_template",
        id
      };

      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      let response = err;

      if (err.response) {
        response = {
          data: err.response.data,
          statusText: err.response.statusText,
          status: err.response.status
        };
      }

      return response;
    }
  };

  // saveTemplate = async (template: any) => {
  //   try {
  //     const response = await axios.post(``, toJS(template));
  //     return response;
  //   } catch (err) {
  //     return {
  //       data: err.response.data,
  //       statusText: err.response.statusText,
  //       status: err.response.status
  //     };
  //   }
  // };

  getCF7Forms = async () => {
    try {
      const data = {
        action: "get_cf7_list_forms"
      };
      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return {
        data: err.response.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };

  deleteCF7Integration = async (id:number) => {
    try {
      const data = {
        action: "delete_CF7_integration",
        id,
      };
      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return {
        data: err.response.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };

  getCF7Integrations = async () => {
    try {
      const data = {
        action: "get_cf7_integrations"
      };
      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return {
        data: err.response.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };

  createOrUpdateTemplate = async (template: any) => {
    try {
      //const { id, json, screenshot_path, name } = template;
      const data = {
        action: "create_or_update_template",
        html: template.html,
        template: template
      };
      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return {
        data: err.response.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };

  createOrUpdateCF7Integration = async (integration: any) => {
    try {
      //const { id, json, screenshot_path, name } = template;
      const data = {
        action: "create_or_update_integration",
        integration
      };

      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return {
        data: err.response.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };

  checkNeedToUpgrade = async () => {
    try {
      //const { id, json, screenshot_path, name } = template;
      const data = {
        action: "need_to_upgrade",
      };

      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return err;
    }
  }

  isUserPremium = async () => {
    try {
      //const { id, json, screenshot_path, name } = template;
      const data = {
        action: "is_premium",
      };

      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return err;
    }
  }
  deleteTemplate = async (id: number) => {
    try {
      //const { id, json, screenshot_path, name } = template;
      const data = {
        action: "delete_template",
        id
      };

      const response = await axios.post(``, this.wpPrepareDateRequest(data));
      return response;
    } catch (err) {
      return {
        data: err.response.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };

  updateUser = async (values: any) => {
    try {
      const response = await axios.put(
        `${this.BASE_URL}/user/${values.id}`,
        values,
        {
          withCredentials: true
        }
      );
      return response;
    } catch (err) {
      return {
        data: err.response?.data,
        statusText: err.response.statusText,
        status: err.response.status
      };
    }
  };
}

export default Api;
